import { render, staticRenderFns } from "./sharePage.vue?vue&type=template&id=9b5a6ace&scoped=true&"
import script from "./sharePage.vue?vue&type=script&lang=js&"
export * from "./sharePage.vue?vue&type=script&lang=js&"
import style0 from "./sharePage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sharePage.vue?vue&type=style&index=1&id=9b5a6ace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a6ace",
  null
  
)

export default component.exports